import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import ReactGA from 'react-ga';
// import { NavHashLink as NavLink } from 'react-router-hash-link';

import { TweenMax, Power2, TimelineLite, ScrollToPlugin} from "gsap/all";

import ScrollMagic from "./ScrollMagic";

import { Waypoint } from "react-waypoint";

// import { Controller, Scene } from "react-scrollmagic";
// import { Tween, Timeline } from "react-gsap";
import LazyLoad from "react-lazyload";

import spirit from "spiritjs";

import Dock from "./components/dock";

// import Project from './components/Project';

import Icon from "./icon";
import projectData from "./content";
import "./App.scss";


const plugins = [ ScrollToPlugin ] // prevents tree shaking
const scrollController = new ScrollMagic.Controller();
const ScrollContext = React.createContext(scrollController);

// change behaviour of controller to animate scroll instead of jump
scrollController.scrollTo(function(newpos) {
  // var bigSpace = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)*0.12;
  TweenMax.to(window, 0.5, { scrollTo: { y: newpos, ease: Power2.easeInOut } });
});

// function initializeReactGA() {
//     ReactGA.initialize('UA-61172109-2');
//     ReactGA.pageview(window.location.pathname + window.location.search);
// }

// spirit.setup({
//   tween: TweenMax,
//   timeline: TimelineLite
// })

var heroAnimation = {"version_app":"1.1.3","version_extension":"1.3.13","version_runtime":"2.4.1","groups":[{"root":{"path":"/html[1]/body[1]","id":null},"name":"portfolio-hero","timeScale":1,"timelines":[{"type":"dom","label":"#progressBar","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='rect'][2]","id":"progressBar"},{"type":"dom","label":"#table","path":"*[local-name()='g'][1]/*[local-name()='g'][2]","id":"table"},{"type":"dom","label":"#switch","path":"*[local-name()='g'][1]/*[local-name()='g'][3]","id":"switch"},{"type":"dom","props":{"rotation":{"0s":"0","2.9137109375s":"360","6.092304067460318s":{"value":"720","ease":"Power2.easeOut"}}},"label":"#arc","path":"*[local-name()='g'][1]/*[local-name()='g'][4]","id":"arc"},{"type":"dom","label":"#window","path":"*[local-name()='g'][1]/*[local-name()='g'][5]","id":"window"},{"type":"dom","label":"#dots","path":"*[local-name()='g'][1]/*[local-name()='g'][6]","id":"dots"},{"type":"dom","label":"#progressBarBG","path":"*[local-name()='g'][1]/*[local-name()='g'][1]/*[local-name()='rect'][1]","id":"progressBarBG"},{"type":"dom","props":{"scaleX":{"0s":"0","2.0648168447066326s":{"value":"1.19","ease":"Power4.easeOut"},"3.4210746729651156s":{"value":"1.19","ease":"Power4.easeOut"},"5.187133592081454s":{"value":"0","ease":"Power2.easeIn"}},"transformOrigin":{"0s":"0% 50%"}},"label":"#progressBarFill","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='rect'][3]","id":"progressBarFill"},{"type":"dom","label":"#cell1","path":"*[local-name()='g'][1]/*[local-name()='g'][2]/*[local-name()='rect'][1]","id":"cell1"},{"type":"dom","label":"#cell2","path":"*[local-name()='g'][1]/*[local-name()='g'][2]/*[local-name()='rect'][2]","id":"cell2"},{"type":"dom","label":"#cell3","path":"*[local-name()='g'][1]/*[local-name()='g'][2]/*[local-name()='rect'][3]","id":"cell3"},{"type":"dom","label":"#switchBg","path":"*[local-name()='g'][1]/*[local-name()='g'][3]/*[local-name()='rect'][1]","id":"switchBg"},{"type":"dom","props":{"x":{"0.8958550012483194s":"0px","2.010966197434642s":{"value":"319","ease":"Power2.easeOut"},"2.3810603858912818s":{"value":"319","ease":"Power2.easeOut"},"3.002255217191152s":{"value":"0px","ease":"Power2.easeOut"}}},"label":"#switchKnob","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='g'][1]/*[local-name()='circle'][1]","id":"switchKnob"},{"type":"dom","props":{"opacity":{"4.452102253401361s":"1","5.7286328125s":"0"},"stroke-dasharray":{"0s":"2500","2.8966015625s":"2500"},"stroke-dashoffset":{"0s":"2500","5.7137890625s":{"value":"0","ease":"Power2.easeInOut"}}},"label":"#arcCircle","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='circle'][1]","id":"arcCircle"},{"type":"dom","label":"#windowBg","path":"*[local-name()='g'][1]/*[local-name()='g'][5]/*[local-name()='g'][1]/*[local-name()='circle'][1]","id":"windowBg"},{"type":"dom","props":{"y":{"0s":"154","4.249720583545918s":{"value":"-324","ease":"Power2.easeOut"},"5.7948046875s":{"value":"146","ease":"Power3.easeIn"}}},"label":"#windowFill","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='g'][2]/*[local-name()='g'][1]/*[local-name()='rect'][1]","id":"windowFill"},{"type":"dom","props":{"scale":{"0s":"0.75","0.3005859375s":{"value":"1","ease":"Power2.easeIn"},"0.6194149709302326s":{"value":"0.75","ease":"Power2.easeOut"}}},"label":"#dot1","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='circle'][3]","id":"dot1"},{"type":"dom","props":{"scale":{"0.28706213662790697s":"1","0.5577513709880756s":{"value":"1.5","ease":"Power2.easeIn"},"0.8206410875578432s":{"value":"1","ease":"Power2.easeOut"}}},"label":"#dot2","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='circle'][6]","id":"dot2"},{"type":"dom","props":{"scale":{"0.6743359375s":"1","0.9139813855229592s":{"value":"1.5","ease":"Power2.easeIn"},"1.1592977834302327s":{"value":"1","ease":"Power2.easeOut"}}},"label":"#dot3","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='circle'][7]","id":"dot3"},{"type":"dom","props":{"scale":{"1.1129266980229588s":"1","1.320075135522959s":{"value":"1.5","ease":"Power2.easeIn"},"1.5635946584302325s":{"value":"1","ease":"Power2.easeOut"}}},"label":"#dot4","path":"div[1]/div[1]/header[1]/div[1]/*[local-name()='svg'][1]/*[local-name()='circle'][8]","id":"dot4"}]}]};
spirit.loadAnimation({
  animationData: heroAnimation,
  loop: true
});

let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

// const tile = document.querySelectorAll(".tile");

// const tileScene = new ScrollMagic.Scene({
//     triggerElement: tile,
//     triggerHook: 0.6
//   })
//     .setTween(TweenMax.from(tile, 1, { opacity: 0, x: -100 })) //addd class to project 01 .addIndicators
//     .addTo(scrollController);

class ProjectNav extends React.Component {
  constructor(props) {
    super(props);
    this.projectEl = null;
  }
  componentDidMount() {
    this.tween = new TimelineLite().staggerFromTo(
      ".tick",
      0.3,
      { opacity: 0, y: 0, scaleX: 0.1 },
      { opacity: 1, y: 0, scaleX: 1, ease: Power2.easeOut },
      0.05
    );
    new ScrollMagic.Scene({
      triggerElement: ".intro",
      triggerHook: "onLeave",
      offset: 200 // start this scene after scrolling for 50px
    })
      .setTween(this.tween)
      .addTo(scrollController);
  }

  render() {
    const navItems = projectData.projects.map((project, index) => (
      <Dock.Item
        key={index}
        id={project.title.replace(/\s+/g, "-").toLowerCase() + "-nav-item"}
      >
        <NavLink
          className="tick"
          to={"/" + project.title.replace(/\s+/g, "-").toLowerCase()}
          activeClassName="active"
          onClick={function() {
            // alert("Hello");
            TweenMax.to(window, 0.6, {
              scrollTo: "#" + project.title.replace(/\s+/g, "-").toLowerCase(),
              ease: Power2.easeOut
            });
            // scrollController.scrollTo(
            //   "#" + project.title.replace(/\s+/g, "-").toLowerCase()
            // );
          }}
          // scroll={el => scrollController.scrollTo(el)}
        >
          <span className="label">
            {project.title}

            {project.hasOwnProperty("role") ? (
              <span className="role">{project.role}</span>
            ) : (
              ""
            )}
          </span>
        </NavLink>
      </Dock.Item>
    ));

    return (
      <div className="project-nav">
        <Dock
          className="dock"
          height={280}
          magnification={3}
          magnifyDirection="center"
          ref={div => (this.projectEl = div)}
        >
          {navItems}
        </Dock>
      </div>
    );
  }
}

class ProjectList extends React.Component {
  constructor(props) {
    super(props);
    this.div = null;
    this.handleEnter = this.handleEnter.bind(this);
    this.state = {
      isDimmed: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isDimmed: nextProps.navIsOpen });
  }

  handleEnter(event) {
    // console.log("Waypoint enter " + JSON.stringify(event, 4));
    // this.divinwaypoint.style.opacity = 0;
  }

  render() {
    // console.log("isDimmed: " + this.state.isDimmed);
    const projects = projectData.projects.map(project => (
      // <Waypoint onEnter={this.handleEnter}>
      <div>
        <ProjectWithProps project={project} />
      </div>
      // </Waypoint>
    ));
    return (
      <section
        className={
          this.props.navIsOpen
            ? "section project-list dim"
            : "section project-list"
        }
        ref={div => (this.div = div)}
      >
        <h3 className="huge">Selected work</h3>
        {projects}
      </section>
    );
  }
}

class Project extends React.Component {
  constructor(props) {
    super(props);
    this.myTween = null;
    this.detailsDiv = null;
    this.headlineEl = null;
    this.projectEl = null;
    this.scene = null;
    this.state = {
      // height: 0,
      inview: false
    };
    // this.updateHeight = this.updateHeight.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
  }
  handleEnter() {
    // console.log("Entering: " + this.props.project.title);
    this.setState({ inview: false });

    var elm = this.headlineEl;
    var newone = elm.cloneNode(true);
    var parent = elm.parentNode;
    if (parent !== null) {
      parent.replaceChild(newone, elm);
    }

    this.setState({ inview: true });

    //     var elm = this,
    // var newone = elm.cloneNode(true);
    // elm.parentNode.replaceChild(newone, elm);

    // console.log("Entering Project: " + this.props.project.title);

    // document.body.style = 'background: ' + this.props.project.color + ';';

    this.props.history.push(
      "/" + this.props.project.title.replace(/\s+/g, "-").toLowerCase()
    );
  }

  handleLeave() {
    // this.props.history.push('/');
    // console.log("Leaving: " + this.props.project.title);
  }

  // updateHeight() {
  //   if (this.state.height !== this.projectEl.clientHeight) {
  //     this.setState({ height: this.projectEl.clientHeight });
  //     this.scene.duration(this.state.height);
  //   }
  // }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateHeight);
  }

  componentDidMount() {
    // Updating project navigation
    // var _self = this;
    var scene = (this.scene = new ScrollMagic.Scene({
      triggerElement: this.projectEl,
      triggerHook: 0.5,
      offset: 0 // start this scene after scrolling for 50px
    })
      // .on("enter leave", function(e) {
      //   if (e.type === "enter") {
          // _self.handleEnter();
        // }
        // else {
        //  if(scrollController.scrollPos() < window.innerHeight) {
        //   _self.handleLeave();
        //  }
        // }
      // })
      .addTo(scrollController));

    // Animating in details text
    this.myTween = TweenMax.fromTo(
      this.detailsDiv,
      0.7,
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, ease: Power2.easeOut, delay: 0.1 }
    );
    new ScrollMagic.Scene({
      triggerElement: this.projectEl,
      triggerHook: 1,
      offset: 200 // start this scene after scrolling for 50px
    })
      .setTween(this.myTween)
      .addTo(scrollController);

    // this.updateHeight();
    // window.addEventListener("resize", this.updateHeight);
  }

  render() {
    var handle = this.props.project.title.replace(/\s+/g, "-").toLowerCase();
    const tiles = this.props.project.tiles.map(tile => <Tile tile={tile} />);

    return (
      <Waypoint onEnter={this.handleEnter} bottomOffset="10%">
        <div
          className={"project " + this.props.project.view}
          id={handle}
          ref={div => (this.projectEl = div)}
        >
          <div className="details" ref={div => (this.detailsDiv = div)}>
            <h3
              className="big sketch-loader"
              ref={div => (this.headlineEl = div)}
            >
              <span>{this.props.project.title}</span>
            </h3>{" "}
            <p>{this.props.project.description}</p>
            {this.props.project.hasOwnProperty("collaboration") ? (
              <p className="collaboration">
                {" "}
                with {this.props.project.collaboration} · {this.props.project.role}
              </p>
            ) : (
              ""
            )}
          </div>

          <div className="tile-list">
            <ul>{tiles}</ul>
          </div>
        </div>
      </Waypoint>
    );
  }
}

// const ProjectWithRef = React.forwardRef((props, ref) => {
//   return <Project innerRef={ref} {...props} />;
// });

const ProjectWithProps = withRouter(Project);

class Tile extends React.Component {
  constructor(props) {
    super(props);
    this.myElement = null;
    // reference to the animation
    this.myTween = null;
  }

  componentDidMount() {
    this.myTween = TweenMax.fromTo(
      this.myElement,
      0.5,
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0 }
    );
    new ScrollMagic.Scene({
      triggerElement: this.myElement,
      triggerHook: "onEnter",
      reverse: false,
      // duration: 300,
      offset: 50 // start this scene after scrolling for 50px
    })
      .setTween(this.myTween)
      .addTo(scrollController);
  }

  renderTileContent(tile) {
    const type = tile.type;
    switch (type) {
      case "video":
        return (
          <VideoTile
            tile={this.props.tile}
            vidSrc={require("./assets/work/" + this.props.tile.src + ".mp4")}
            posterSrc={require("./assets/work/" +
              this.props.tile.src +
              "-poster.png")}
          />
        );
      default:
        return <ImageTile tile={this.props.tile} />;
    }
  }

  render() {
    return (
      <li
        className={
          this.props.tile.hasOwnProperty("desc")
            ? "tile has-caption " + this.props.tile.frame
            : "tile " + this.props.tile.frame
        }
        ref={div => (this.myElement = div)}
        style={
          this.props.tile.hasOwnProperty("")
            ? { backgroundColor: this.props.tile.color }
            : {}
        }
      >
        {this.renderTileContent(this.props.tile)}
      </li>
    );
  }
}

const _loaded = {};

class ImageTile extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    loaded: _loaded[this.props.tile.src]
  };

  //define our loading and loaded image classes
  static defaultProps = {
    className: "preview",
    loadingClassName: "img-loading",
    loadedClassName: "img-loaded"
  };

  // image onLoad handler to update state to loaded
  onLoad = () => {
    _loaded[this.props.tile.src] = true;
    this.setState(() => ({ loaded: true }));
  };

  render() {
    let { className, loadedClassName, loadingClassName, ...props } = this.props;
    className = `${className} ${
      this.state.loaded ? loadedClassName : loadingClassName
    }`;

    return (
      <div className={"preview-container " + props.tile.frame}>
        <div className="preview-frame" />
        <div className="preview-screen">
          <LazyLoad offset={500} throttle={500}>
            <img
              src={require("./assets/work/" + props.tile.src)}
              className={className}
              onLoad={this.onLoad}
              // title={props.tile.desc}
              alt={props.tile.desc}
            />
          </LazyLoad>
        </div>
      </div>
    );
  }
}   

class VideoTile extends React.Component {
  static contextType = ScrollContext;
  //initial state: image loaded stage

  state = {
    playback: "poster",
    loaded: _loaded[this.props.posterSrc],
    loader: "",
    inView: false,
    width: window.innerWidth
  };

  //define our loading and loaded image classes
  static defaultProps = {
    className: "poster",
    loadingClassName: "img-loading",
    loadedClassName: "img-loaded"
  };

  // image onLoad handler to update state to loaded
  onLoad = () => {
    _loaded[this.props.posterSrc] = true;
    this.setState(() => ({ loaded: true }));
  };

  // onLoadStart = () => {
  //   // alert("Started loading");
  //   this.setState({playback: "loading"});
  // };

  // onCanPlay = () => {
  //   // alert("Done loading!");
  //   // this.vid.currentTime = 0;
  //   // this.vid.play();
  //   // this.setState({playback: "playing"});
  //   // if (this.state.playback === "ended") {
  //   // }
  //   if (this.state.playback === "waitingToLoad") {
  //     this.setState({playback: "playing"});
  //     this.vid.play();
  //     console.log("Will play now!");
  //   }
  // };

  constructor(props) {
    super(props);
    this.vid = null;
    // this.replay = this.replay.bind(this);
    // this.ended = this.ended.bind(this);
  }

  // handleEnter() {
  //   console.log("Entering Tile: " + this.props.tile.desc);
  //   this.setState({inView: true});
  //   this.videoLoad();
  //   this.videoPlay();
  //   // if (this.state.playback === "ended") {
  //   // } else if (this.vid !== null && this.vid.readyState === 4) {
  //   //   setTimeout(
  //   //     function() {
  //   //       this.setState({playback: "playing"});
  //   //       this.vid.play();
  //   //     }.bind(this),
  //   //     500 // wait a sec before playign to give user time to scroll
  //   //   );
  //   // } else {
  //   //   console.log("Waiting to load this one");
  //   //   this.setState({playback: "waitingToLoad"});
  //   // }
  // }
  // handleLeave = () => {
  //   console.log("Leaving Tile: " + this.props.tile.desc);
  //   this.setState({inView: false});
  //   this.videoPause();
  // };

  // play = () => {
  //   this.setState({playback: "playing"});
  //   this.vid.play();
  // };

  // loaded = () => {
  //   this.setState({playback: "playing"});
  //   this.vid.play();
  // };

  replay = () => {
    console.log("replay");

    if (this.vid.ended) {
      this.videoPlay();
    } else if (this.state.width <= 500) {
      console.log("replay!");

      this.vid.play();
      this.setState({ loader: "loaded" });
    }
  };

  ended() {
    this.vid.currentTime = 1;
  }

  // videoToggle = () => {
  //     $(document).on('scroll', this.videoToggle);

  // };

  videoLoad = () => {
    if (this.state.loader === "") {
      this.setState({ loader: "loading" }); //this will set the preload attr to auto
      this.vid.addEventListener("canplay", this.videoPlay);
      this.vid.addEventListener("canplaythrough", this.videoPlay);
    }
  };

  videoPlay = () => {
    // console.log("Can play?");
    if (this.vid.paused && this.vid.readyState >= 1) {
    // console.log("Can play!");
      if (this.state.inView) {
        // console.log("Play video");

        this.vid.play();
        this.setState({ loader: "loaded" }); // this will remove loading indicator 
      this.vid.removeEventListener("canplay", this.videoPlay);
      this.vid.removeEventListener("canplaythrough", this.videoPlay);
      }
    }
  };

  videoPause = () => {
    if (this.vid !== null) {
      if (!this.vid.paused) {
        this.vid.pause();
      }
    }
  };

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }
  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  handlePositionChange = ({ currentPosition }) => {
    // console.log(currentPosition + " " + this.props.tile.desc);
    if (this.state.width >= 768) {
      if (currentPosition === Waypoint.inside && !this.state.inView) {
        // console.log("Entering Tile: " + this.props.tile.desc);
        this.setState({ inView: true });
        this.videoLoad();
        // setTimeout(
        //   function() {
        this.videoPlay();
          // }.bind(this),
          // 500 // wait a sec before playign to give user time to scroll
        // );
      } else if (this.state.inView) {
        // console.log("Leaving Tile: " + this.props.tile.desc);
        this.setState({ inView: false });
        this.videoPause();
      }
    }
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 768;
    let { className, loadedClassName, loadingClassName } = this.props;
    className = `${className} ${
      this.state.loaded ? loadedClassName : loadingClassName
    }`;
    let containerClass =
      "preview-container vid-container " + this.props.tile.frame;

    if (this.state.loader === "loaded") {
      containerClass += " loaded";
    }

    return (
      <Waypoint
        // onEnter={this.handleEnter}
        // onLeave={this.handleLeave}
        onPositionChange={this.handlePositionChange}

        // fireOnRapidScroll={false}
        // topOffset={"50%"}
        // bottomOffset={"20%"} // bottomOffset={"50%"} triggers when the bottom of the viewport is 50% of the viewport from the top of the lement
      >
        <div className={containerClass} onClick={this.replay}>
          <div className="preview-frame" />
          <div className="preview-screen">
            <img
              src={this.props.posterSrc}
              onLoad={this.onLoad}
              className={className}
              alt={this.props.tile.desc}
            />
            <video
              muted
              playsInline
              loop
              preload={`${this.state.loader === "" ? "none" : "auto"}`}
              src={this.props.vidSrc}
              // alt={this.props.desc}
              ref={div => (this.vid = div)}
              // onEnded={this.ended}
              // onLoadStart={this.onLoadStart}
              // onLoadedData={this.play}
              controls={isMobile}
              onCanPlay={this.videoPlay}
              // className={`${this.state.playback === "playing" ? "vid vid-playing" : "vid vid-idle"}`}
              className={`${
                this.state.loader === "loaded"
                  ? "vid vid-loaded"
                  : "vid vid-loading"
              }`}
              // title={this.props.tile.desc}
            />
          </div>
        </div>
      </Waypoint>
    );
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navIsOpen: false,
          width: window.innerWidth

    };
    this.navIsOpen = this.navIsOpen.bind(this);
    this.navIsClosed = this.navIsClosed.bind(this);
    this.scrollAffordanceDiv = null;
    this.heroDetails = null;
  }

  componentDidMount() {
    ReactGA.initialize('UA-61172109-2');
    ReactGA.pageview(window.location.pathname + window.location.search);
        
    this.myTween = new TimelineLite().fromTo(
      this.heroDetails,
      0.3,
      { opacity: 1, y: 0 },
      { opacity: 0, y: 1 },0
    ).fromTo(
      this.scrollAffordanceDiv,
      0.3,
      { opacity: 1, y: 0 },
      { opacity: 0, y: 1 },0
    );

    new ScrollMagic.Scene({
      triggerElement: ".project-list",
      triggerHook: "onEnter",
      offset: 250
    })
      .setTween(this.myTween)
      .addTo(scrollController);
  }

  navIsOpen() {
    this.setState(state => ({
      navIsOpen: true
    }));

    // console.log("NavIsOpen: " + this.state.navIsOpen);
  }

  navIsClosed() {
    this.setState(state => ({
      navIsOpen: false
    }));
    // console.log("NavIsOpen: " + this.state.navIsOpen);
  }

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }
  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    return (
      <div className="App">
        <nav className="nav-left">
          <div
            onMouseEnter={this.navIsOpen}
            onMouseLeave={this.navIsClosed}
            ref={div => (this.navDiv = div)}
          >
            <ProjectNav />
          </div>
        </nav>

        <div className="nav-right">
          <span className="site-title">
            <NavLink
              to={"/"}
              activeClassName="active"
              location={{
                pathname: document.location.pathname + document.location.hash
              }}
              onClick={function() {
                // scrollController.scrollTo(0);
                TweenMax.to(window, 0.6, { scrollTo: 0, ease: Power2.easeOut });
              }}
            >
              <span className="label f-link">
                  Louis Harboe
              </span>
            </NavLink>
          </span>

          <div className="socials">
            <ul>
              <li>
                <a href="http://twitter.com/spiralstairs" className="f-link">
                  <Icon name="icon-twitter" />
                </a>
              </li>
              <li>
                <a href="http://instagram.com/lharboe" className="f-link">
                  <Icon name="icon-instagram" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <header className="section intro" id="intro">
          <div className="hero">
                    <div className="overlay"></div>


     <svg width={1640} height={1450} viewBox="0 0 1640 1450" preserveAspectRatio="xMidYMid slice" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={1640} height={1450} fill="#F2F2F2" />
      <circle  data-spirit-id="arcCircle" id="circle1" cx={1091} cy={739} r="396.5" fill="white" stroke="black" strokeWidth={3} />
      <circle  data-spirit-id="arcCircle" id="circle2" cx={1091} cy={739} r="396.5" fill="white" stroke="black" strokeWidth={3} />
      <rect  data-spirit-id="progressBar" x="168.5" y="211.5" width={921} height={259} fill="white" stroke="black" strokeWidth={3} />
      <rect  data-spirit-id="progressBarFill" x="168.5" y="211.5" width={669} height={259} fill="white" stroke="black" strokeWidth={3} />
      <rect id="cell1" x="542.5" y="737.5" width={945} height={155} fill="white" stroke="black" strokeWidth={3} />
      <rect id="cell2" x="542.5" y="932.5" width={945} height={155} fill="white" stroke="black" strokeWidth={3} />
      <rect id="cell3" x="542.5" y="1135.5" width={945} height={155} fill="white" stroke="black" strokeWidth={3} />
      <g id="switch">
        <rect id="switchBg" x="398.5" y="527.5" width={464} height={145} rx="72.5" fill="white" stroke="black" strokeWidth={3} />
        <circle  data-spirit-id="switchKnob" cx={471} cy={600} r="72.5" fill="white" stroke="black" strokeWidth={3} />
      </g>
      <g id="porthole">
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x={116} y={813} width={479} height={479}>
          <circle id="portholeMask" cx="355.5" cy="1052.5" r={238} fill="white" stroke="black" strokeWidth={3} />
        </mask>
        <g mask="url(#mask0)">
          <circle id="portholeBG" cx="355.5" cy="1052.5" r={238} fill="white" stroke="black" strokeWidth={3} />
          <rect  data-spirit-id="windowFill" x="117.5" y="1135.5" width={476} height={500} fill="white" stroke="black" strokeWidth={3} />
          <circle id="portholeOverlap" cx="355.5" cy="1052.5" r={238} stroke="black" strokeWidth={3} />
        </g>
      </g>
      <circle  data-spirit-id="dot1" cx={964} cy={341} r="72.5" fill="white" stroke="black" strokeWidth={3} />
      <circle id="bullet1" r="18.5" transform="matrix(-1 0 0 1 615 814)" fill="white" stroke="black" strokeWidth={3} />
      <circle id="bullet3" r="18.5" transform="matrix(-1 0 0 1 615 1214)" fill="white" stroke="black" strokeWidth={3} />
      <circle  data-spirit-id="dot2" cx={1137} cy={341} r="48.5" fill="white" stroke="black" strokeWidth={3} />
      <circle  data-spirit-id="dot3" cx={1296} cy={341} r="48.5" fill="white" stroke="black" strokeWidth={3} />
      <circle  data-spirit-id="dot4" cx={1439} cy={341} r="48.5" fill="white" stroke="black" strokeWidth={3} />
      <line id="Line" x1="542.5" y1={344} x2="542.5" y2={1450} stroke="black" strokeWidth={3} />
      <line id="Line_2" x1="694.5" y1={344} x2="694.5" y2={1450} stroke="black" strokeWidth={3} />
      <line id="Line_3" x1="1089.5" y1={341} x2="1089.5" y2={1450} stroke="black" strokeWidth={3} />
      <line id="Line_4" x1="1347.5" y1={341} x2="1347.5" y2={1450} stroke="black" strokeWidth={3} />
      <line id="Line_5" x1="1487.5" y1={341} x2="1487.5" y2={1450} stroke="black" strokeWidth={3} />
      <line id="Line_6" x1="168.5" y1="-6.55671e-08" x2="168.5" y2={1450} stroke="black" strokeWidth={3} />
      <line id="Line_7" x1="1.31134e-07" y1="211.5" x2={1640} y2="211.5" stroke="black" strokeWidth={3} />
      <line id="Line_8" x1={77} y1="339.5" x2={1489} y2="339.5" stroke="black" strokeWidth={3} strokeDasharray="20 20" />
      <line id="Line_9" x1={355} y1="598.5" x2={1091} y2="598.5" stroke="black" strokeWidth={3} strokeDasharray="20 20" />
      <line id="Line_10" x1="354.5" y1={738} x2="354.5" y2={1378} stroke="black" strokeWidth={3} strokeDasharray="20 20" />
      <line id="Line_11" x1={503} y1="1011.5" x2={1574} y2="1011.5" stroke="black" strokeWidth={3} strokeDasharray="20 20" />
      <line id="Line_12" x1={346} y1="527.5" x2={1091} y2="527.5" stroke="black" strokeWidth={3} />
      <line id="Line_13" x1={346} y1="672.5" x2={1091} y2="672.5" stroke="black" strokeWidth={3} />
      <line id="Line_14" x1={490} y1="737.5" x2={1640} y2="737.5" stroke="black" strokeWidth={3} />
      <line id="Line_15" x1={490} y1="892.5" x2={1640} y2="892.5" stroke="black" strokeWidth={3} />
      <line id="Line_16" x1={490} y1="932.5" x2={1640} y2="932.5" stroke="black" strokeWidth={3} />
      <line id="Line_17" x1={490} y1="1087.5" x2={1640} y2="1087.5" stroke="black" strokeWidth={3} />
      <line id="Line_18" x1={490} y1="1135.5" x2={1640} y2="1135.5" stroke="black" strokeWidth={3} />
      <line id="Line_19" x1={490} y1="1290.5" x2={1640} y2="1290.5" stroke="black" strokeWidth={3} />
      <line id="Line_20" x1="1.31134e-07" y1="470.5" x2={1640} y2="470.5" stroke="black" strokeWidth={3} />
</svg>




            </div>
             <div className="spacer">
            <span>Louis Harboe</span>
            <div className="socials">
              <ul>
                <li>
                  <a href="http://twitter.com/spiralstairs" className="f-link">
                    <Icon name="icon-twitter" />
                  </a>
                </li>
                <li>
                  <a href="http://instagram.com/lharboe" className="f-link">
                    <Icon name="icon-instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="details" ref={div => (this.heroDetails = div)}>
            <h3>
              <span className="huge hero-title">
                <span className={this.state.width <= 768 ? "" : "sketch-loader line-1"}><span>Designer, prototyper, </span></span> 
                <span className={this.state.width <= 768 ? "" : "sketch-loader line-2"}><span>and developer.</span></span>
              </span>
            </h3>
            <p className={this.state.width <= 768 ? "" : "hero-desc"}>Based in Los Angeles</p>
          </div>
          <div
            className="caret"
            ref={div => (this.scrollAffordanceDiv = div)}
            onClick={function() {
              TweenMax.to(window, 0.6, {
                scrollTo: { y: ".project-list", offsetY: 100 },
                ease: Power2.easeOut
              });
            }}
          >
            <svg
              width="36"
              height="21"
              viewBox="0 0 36 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.585938 3.41424L3.41436 0.585815L18.0002 15.1716L32.5859 0.585815L35.4144 3.41424L18.0002 20.8285L0.585938 3.41424Z"
                fill="black"
              />
            </svg>
            <span className="small">Scroll</span>
          </div>
        </header>

        <div ref={div => (this.projectListDiv = div)}>
          <ProjectList navIsOpen={this.state.navIsOpen} />
        </div>

        <footer className="section footer">
          <p>Hi, I'm Louis.</p>
          <p>I'm an interface designer at <a href="http://syngspace.com" target="_blank" className="u-link">Syng</a>. Previously, I studied technology and art at the University of Southern California. I currently live in Los Angeles.</p>
          <p>
            View{" "}
            <a href="https://harboe.me/resume.pdf" target="_blank" className="u-link">
              resume
            </a>{" "}
            or get in touch on{" "}
            <a href="http://twitter.com/spiralstairs" target="_blank" className="u-link">
              Twitter
            </a>
            ,{" "}
            <a href="http://instagram.com/lharboe" target="_blank" className="u-link">
              Instagram
            </a>{" "}
            or{" "}
            <a href="mailto:lharboe@me.com" className="u-link">
              email.
            </a>
          </p>
        </footer>
      </div>
    );
  }
}

export default App;
